import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { helpComponentInfo } from "../../../../main/utils/helpTextComponent.util";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { AuthenticationService } from "../../../../main/services/authentication.service";

@Component({
  selector: "help-global-button",
  templateUrl: "./navbar-help-button.component.html",
  styleUrls: ["./navbar-help-button.component.scss"],
})
export class HelpGlobalButtonComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  public helpTextContent: object;
  private currentUrl: string = this.router.url;
  private contentByUser: object[]; // Array con el contenido segun tipo de usuario (0 = superAdmin , 1 = admin, 2 = sender)
  private userRole: string = this.authService.user?.role;

  ngOnInit(): void {
    // Verificar si el usuario está autenticado
    if (this.authService.isLogged) {
      this.handleNavigationChanges(this.router.url);
    }

    // Escuchar cambios en la navegación
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleNavigationChanges(event.url);
      });

    // Mostrar el contenido la primera vez que se abre la aplicación
    //this.handleNavigation(this.router.url);
  }

  handleNavigationChanges(url: string): void {
    this.getContentbyUser();
    this.currentUrl = url;
    this.helpTextContent = null;
    this.updateContent(this.contentByUser);
  }

  /**
   * Updates the help text content based on the current URL.
   * Actualizar el contenido del texto de ayuda basado en la URL actual.
   * @param content - The content to update with.
   */
  updateContent = (content) => {
    let path = ""
    for (let component in content) {
      if (this.currentUrl.includes(content[component].path)) {
        if (content[component].path > path) {
          path = content[component].path;
          this.helpTextContent = content[component].components;
        }
      }
    }
  };

  /**
   * Gets the help content based on the user's role defined on helpComponenInfo structure and current user logged.
   * Obtener el contenido del texto de ayuda basado en el rol del usuario definido en la estructura helpComponentInfo y el usuario actual conectado.
   * @returns {void}
   */
  getContentbyUser = () => {
    for (let user in helpComponentInfo) {
      if (helpComponentInfo[user].role === this.userRole) {
        this.contentByUser = helpComponentInfo[user];
        break;
      }
    }
  };
}
